import { hysteriFetch } from 'hysterics';
import logger from 'ws-scripts/modules/logger';

const fetchVehiclesWrapper = hysteriFetch('ws-compare-vehicle-dealerCodes');

export default async function fetchDealerCodesData({ vehicleAccounts }) {
	let response;
	try {
		response = await fetchVehiclesWrapper(
			'/api/widget/ws-vehicle-compare/getDealerCodesCompare',
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ vehicleAccounts })
			}
		);
	} catch (err) {
		const errorText = `ws-vehicle-compare: Error attempting to retrieve dealer codes data from. ${err.message}`;
		const error = new Error(errorText);
		logger.error(error);
		response = { error: errorText };
	}
	return response;
}
